import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";

const CustomAccordion = styled(Accordion)({
  transition: "all 0.3s ease-in-out",
  "&.Mui-expanded": {
    margin: "8px 0",
  },
});

const faqData = [
  {
    question: "What courses are available at Aakash?",
    answer: "Aakash offers courses for medical, and engineering entrance exams and scholarship exams such as NEET, JEE, Olympiads, NTSE, and NSEs. You can take admission in one-year, two-year, three-year, or four-year courses. You can download the latest prospectus. "
  },
  {
    question: "Can I get a scholarship on Aakash courses?",
    answer: "Yes, Aakash offers various scholarships based on merit and performance in their scholarship exams."
  },
  {
    question: "How do I find an Aakash center?",
    answer: "You can find the nearest Aakash center using their official website’s center locator tool."
  },
  {
    question: "I have some questions regarding courses and the admission process. Can I talk to someone at Aakash?",
    answer: "Yes, you can contact Aakash through their helpline or visit your nearest center for detailed information."
  }
];

const FaqSection = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 2 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: '#1a237e',
          textAlign: 'center',
          mb: 4
        }}
      >
        Frequently Asked Questions
      </Typography>
      {faqData.map((faq, index) => (
        <Accordion
          key={index}
          sx={{
            mb: 2,
            '&:before': { display: 'none' },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: '8px !important'
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a237e' }}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.8 }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}

    </Container>
  );
};

export default FaqSection;
